import { Loader } from 'google-maps'
import GLightbox from 'glightbox'
import Vue from 'vue'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate'
import { required, email, min } from 'vee-validate/dist/rules'
import ContactForm from '../vue/components/contactForm.vue'

export default {
  init() {
    const contactNavItems = document.querySelectorAll('.contact-info-nav a')
    const contactInfoContent = document.querySelectorAll(
      '.contact-info-content'
    )
    const buttonImageMap = document.querySelector('.button-image-map')
    const buttonGetDirection = document.querySelector('.button-get-direction')

    const loader = new Loader('AIzaSyDD2UafGpcekl1uYmyeYLrT2j86w5-mNvA', {
      libraries: ['places'],
      language: SNP.lang,
      // region: 'JP',
    })
    const lat = 13.806128137904883
    const lng = 100.53761979930579
    let map
    const lightbox = GLightbox()

    extend('required', { ...required })
    extend('email', { ...email })
    extend('min', min)

    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)
    new Vue({
      el: '#contact-form',
      components: { ContactForm },
    })

    loader.load().then(function (google) {
      map = new google.maps.Map(document.getElementById('contact-map'), {
        center: { lat, lng },
        zoom: 16,
        mapTypeControl: false,
        streetViewControl: false,
        // scrollwheel: false,
        zoomControl: false,
      })

      const headOfficeInfo = new google.maps.InfoWindow({
        content:
          '<h3>Head Office</h3> <span>1 Siam Cement Rd., <br> Bangsue, Bangkok  <br> 10800, Thailand</span>',
      })

      const headOffice = new google.maps.Marker({
        map,
        draggable: false,
        icon: SNP.marker,
        position: { lat: 13.806128137904883, lng: 100.53761979930579 },
      })

      google.maps.event.addListener(headOffice, 'click', () => {
        window.open('https://maps.app.goo.gl/zmaG9pk4psjefCph8')
      })

      const millIngo = new google.maps.InfoWindow({
        content:
          '<h3>Mill</h3><span>19 Saeng Xuto Road, <br> Tha Pha, Ban Pong, Ratchaburi, <br> 70110, Thailand.</span>',
      })

      const mill = new google.maps.Marker({
        map,
        draggable: false,
        icon: SNP.marker,
        position: { lat: 13.854259949891382, lng: 99.84749233350358 },
      })

      google.maps.event.addListener(mill, 'click', () => {
        window.open('https://maps.app.goo.gl/z9oeag6zapWah2Ly5')
      })

      // millIngo.open(map, mill)
      // headOfficeInfo.open(map, headOffice)
    })

    contactNavItems.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()
        for (const item of contactNavItems) {
          item.classList.remove('is-active')
        }

        for (const item of contactInfoContent) {
          if (item.classList.contains(element.dataset.tab)) {
            item.classList.add('is-visible')
          } else {
            item.classList.remove('is-visible')
          }
        }

        element.classList.add('is-active')

        buttonImageMap.href = element.dataset.map
        buttonGetDirection.href = `https://www.google.com/maps/dir/?api=1&destination=${element.dataset.direction}`
        lightbox.reload()

        const lat = parseFloat(element.dataset.lat)
        const lng = parseFloat(element.dataset.lng)
        const panPoint = new google.maps.LatLng(lat, lng)
        map.panTo(panPoint)
      })
    })

    const inputs = document.querySelectorAll('.form-control')
    for (let index = 0; index < inputs.length; index++) {
      const element = inputs[index]
      element.addEventListener(
        'focus',
        (e) => {
          e.target.closest('.form-group').classList.add('is-focus')
        },
        true
      )

      element.addEventListener(
        'blur',
        (e) => {
          if (!e.target.value) {
            e.target.closest('.form-group').classList.remove('is-focus')
          }
        },
        true
      )
    }
  },
  finalize() {},
}
